<template>
    <div class="lang-selector" @mouseenter="openDropdown" @mouseleave="closeDropdown">
        <img :src="currentLangIcon" width="16" height="16" class="pointer lang-image" />
        <label class="lang-label">
            {{ currentLanguage.toUpperCase() }}
        </label>

        <div v-if="showDropdown" class="lang-dropdown">
            <div v-for="lang in languages" :key="lang.code" class="pointer lang-option"
            :class="{ 'lang-option-selected': lang.code === currentLanguage }"
                @click="selectLanguage(lang.code)" @mouseenter="handleHover(true)">
                <img :src="lang.icon" width="16" height="16" class="lang-option-icon" />
                <span class="lang-option-text">{{
                    lang.code.toUpperCase() }}</span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue';

interface Language {
    code: string;
    icon: string;
    label: string;
    mainLabel: string;
}

interface Props {
    languages: Language[];
    currentLanguage: string;
}

export default {
    name: 'LangDropdown',

    props: {
        languages: {
            type: Array as () => Language[],
            required: true
        },
        currentLanguage: {
            type: String,
            default: 'ru'
        }
    },

    emits: ['language-change'],

    setup(props: Props, { emit }: { emit: (event: 'language-change', lang: string) => void }) {
        const showDropdown = ref(false);

        const currentLangIcon = computed(() => {
            const lang = props.languages.find((lang: Language) => lang.code === props.currentLanguage);
            return lang ? lang.icon : props.languages[0]?.icon || '';
        });

        const selectLanguage = (lang: string) => {
            showDropdown.value = false;
            emit('language-change', lang);
        }

        const openDropdown = () => {
            showDropdown.value = true;
        }

        const closeDropdown = () => {
            showDropdown.value = false;
        }

        const handleHover = (open: boolean) => {
            showDropdown.value = open;
        }

        const handleClickOutside = (event: Event) => {
            const target = event.target as HTMLElement;
            if (!target.closest('.lang-selector')) {
                closeDropdown();
            }
        }

        onMounted(() => {
            document.addEventListener('click', handleClickOutside);
        });

        onUnmounted(() => {
            document.removeEventListener('click', handleClickOutside);
        });

        return {
            showDropdown,
            currentLangIcon,
            selectLanguage,
            openDropdown,
            closeDropdown,
            handleHover
        }
    }
}
</script>

<style scoped>
.lang-selector {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
}

.lang-image {
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    width: 24px;
    height: 24px;
    filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 0.25));
    border-radius: 50px;
}

.lang-label {
    width: 19px;
    height: 18px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #4F4F4F;
    flex: none;
    order: 1;
    flex-grow: 0;
}

.lang-dropdown {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding: 8px 4px;
    gap: 4px;
    position: absolute;
    width: 71px;
    height: 80px;
    left: 30px;
    top: 0;
    background: #FFFFFF;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    z-index: 1000;
}

.lang-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 8px;
    gap: 8px;
    width: 62px;
    height: 20px;
    border-radius: 6px;
    transition: #F5F5F5 0.2s ease;
}

.lang-option-selected .lang-option-text {
    color: #3F884F !important;
}

.lang-option:hover {
    background-color: #F2F2F2;
}

.lang-option-selected:hover {
    background: #F3F8F4 !important;
}

.lang-option.active {
    background-color: #e9e9e9;
}

.lang-option-icon {
    flex-shrink: 0;
}

.lang-option-text {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #333333;
    white-space: nowrap;
}

.pointer {
    cursor: pointer;
}
</style>

.lang-selector {
position: relative;
display: flex;
align-items: center;
gap: 8px;
}

.lang-dropdown {
display: flex;
flex-direction: column;
justify-content: space-between;
align-items: flex-start;
padding: 8px 4px;
gap: 8px;

position: absolute;
width: 71px;
height: 80px;
left: 30px;
top: 0;

background: #FFFFFF;
box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
border-radius: 8px;

z-index: 1000;
/* min-width: 120px;
padding: 4px 0; */
}

.lang-option {
display: flex;
flex-direction: row;
align-items: center;
padding: 0px 8px;
gap: 8px;
width: 62px;
height: 20px;
}

.lang-option:hover {
background-color: #F5F5F5;
}

.lang-option-icon {
flex-shrink: 0;
}

.lang-option-text {
font-family: 'Roboto';
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 18px;
color: #333333;
white-space: nowrap;
}